import { isNonEmptyObject } from './object-utils';
export function deepClone(value) {
    if (value === null || typeof value !== 'object') {
        return value;
    }
    if (value instanceof Date) {
        return new Date(value.getTime());
    }
    if (value instanceof Array) {
        const copy = [];
        value.forEach(elem => {
            copy.push(elem);
        });
        return copy.map((elem) => deepClone(elem));
    }
    if (typeof value === 'object' && isNonEmptyObject(value)) {
        const copy = Object.assign({}, value);
        Object.keys(copy).forEach(key => {
            copy[key] = deepClone(copy[key]);
        });
        return copy;
    }
    return value;
}
//# sourceMappingURL=deep-clone.js.map